/** * @author SwathiDivya Bhavaraju * @email swathidivya.bhavaraju@ul.com * @create date 2021-04-22
12:20:32 * @modify date 2021-04-22 12:20:32 * @desc [description] */
<template>
  <div class="row m-0">
    <div class="border-box">
      <div class="plr-20">
        <span class="ft-20">Account Details</span>
        <span class="float-right link-history" @click="openAccountHistory">History</span>
      </div>
      <div><hr /></div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">Account Name :</div>
        <div class="ft-normal" v-if="!updateAccount">
          {{ account.account_name }}
        </div>
        <div class="row col-xs-12 col-sm-6 col-md-5" v-else>
          <input
            type="text"
            class="form-control"
            placeholder="Legal Company Name"
            v-model="editAccount.account_name"
            maxlength="50"
            required
            @input="debounceInput()"
            :class="[
              $v.editAccount.account_name.$error ? 'invalid-border' : '',
              companyExists ? 'warning-border' : ''
            ]"
          />
          <span class="required_astric left-190" v-if="!editAccount.account_name">*</span>
          <div v-if="$v.editAccount.account_name.$error">
            <div class="custom-error-class" v-if="!$v.editAccount.account_name.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-else-if="!$v.editAccount.account_name.minLength">
              Minimum 2 characters required.
            </div>
            <div class="custom-error-class" v-else-if="!$v.editAccount.account_name.isAlphaNum">
              First character should be alphanumeric
            </div>
          </div>
          <div v-else-if="companyExists">
            <div class="custom-warning-class">
              Your company already exists in our system. Contact your organization for more
              information.
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">Account Type :</div>
        <div class="ft-normal">
          {{ account.account_type }}
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">RAMS ID :</div>
        <div class="ft-normal">
          {{ account.account_id }}
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="cursor-pointer w-175" @click="$emit('selectedMenu', 'users')">
          Number of users :
        </div>
        <div class="ft-normal">
          {{ account.number_of_users }}
        </div>
      </div>
      <div class="d-flex row m-0 plr-20" v-if="account_owner">
        <div class="w-175" v-if="account_owner && account.account_type === 'REP'">
          REP Account Owner :
        </div>
        <div class="w-175" v-if="account_owner && account.account_type === 'Commercial'">
          Account Owner :
        </div>
        <div class="ft-normal">
          <div class="member_img">
            <span v-if="account_owner.profile_pic" class="relative-pos">
              <img class="profile-pic" :src="account_owner.profile_pic" alt="profile-pic" />
            </span>
            <span class="profile-pic profile-pic-title custom-profile-pic-title relative-pos" v-else
              >{{ getInitials(account_owner.first_name, account_owner.last_name) }}
            </span>
          </div>
          <div class="member-text">
            <div class="member-name">
              {{ account_owner.first_name + ' ' + account_owner.last_name }}
            </div>
            <div class="member-email">{{ account_owner.email }}</div>
          </div>
        </div>
      </div>
      <div class="row m-0 plr-20 align-right">
        <template v-if="!updateAccount">
          <button type="button" class="btn emergo-green-button" @click="accountUpdate()">
            Update
          </button>
        </template>
        <template v-else>
          <button
            type="button"
            class="btn emergo-white-button"
            @click="
              updateAccount = false;
              companyExists = false;
            "
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn emergo-green-button ml-15 xs-mrt-10"
            :disabled="disableAccountSave"
            @click="updateAccountName"
          >
            Save
          </button>
          <!-- :disabled="disableButtonForProfile || loaderStatus" -->
        </template>
      </div>
    </div>
    <div class="border-box">
      <div class="plr-20 ft-20">Contact Details</div>
      <div class="p-0"><hr /></div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">Street Address :</div>
        <div class="ft-normal" v-if="!updateContact">
          {{ account.street_address }}
        </div>
        <div class="row col-xs-12 col-sm-6 col-md-5" v-else>
          <input
            type="text"
            class="form-control"
            placeholder="Street Address"
            :class="$v.editContactDetails.street_address.$error ? 'invalid-border' : ''"
            v-model="editContactDetails.street_address"
            @blur="$v.editContactDetails.street_address.$touch()"
          />
          <div
            class="custom-error-class"
            v-if="
              !$v.editContactDetails.street_address.isAllowedCharacters &&
              $v.editContactDetails.street_address.$error
            "
          >
            {{ specialCharacterErrMsg }}
          </div>
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">City :</div>
        <div class="ft-normal" v-if="!updateContact">
          {{ account.city }}
        </div>
        <div class="row col-xs-12 col-sm-6 col-md-5" v-else>
          <input
            type="text"
            class="form-control"
            :class="$v.editContactDetails.city.$error ? 'invalid-border' : ''"
            placeholder="City"
            size="60"
            maxlength="50"
            v-model="editContactDetails.city"
            @blur="$v.editContactDetails.city.$touch()"
          />
          <div v-if="$v.editContactDetails.city.$error">
            <div class="custom-error-class" v-if="!$v.editContactDetails.city.minLength">
              Minimum 3 characters required.
            </div>
            <div
              class="custom-error-class"
              v-else-if="!$v.editContactDetails.city.isAllowedCharacters"
            >
              {{ specialCharacterErrMsg }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">State :</div>
        <div class="ft-normal" v-if="!updateContact">
          {{ account.state }}
        </div>
        <div class="row col-xs-12 col-sm-6 col-md-5" v-else>
          <input
            type="text"
            class="form-control"
            placeholder="State"
            size="60"
            maxlength="50"
            :class="$v.editContactDetails.state.$error ? 'invalid-border' : ''"
            v-model="editContactDetails.state"
            @blur="$v.editContactDetails.state.$touch()"
          />
          <div
            class="custom-error-class"
            v-if="
              !$v.editContactDetails.state.isAllowedCharacters && $v.editContactDetails.state.$error
            "
          >
            {{ specialCharacterErrMsg }}
          </div>
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">Zip :</div>
        <div class="ft-normal" v-if="!updateContact">
          {{ account.zip }}
        </div>
        <div class="row col-xs-12 col-sm-6 col-md-5" v-else>
          <input
            type="text"
            class="form-control"
            placeholder="Zip/postal code"
            :class="$v.editContactDetails.zip.$error ? 'invalid-border' : ''"
            maxlength="15"
            @blur="$v.editContactDetails.zip.$touch()"
            v-model="editContactDetails.zip"
          />
          <div v-if="$v.editContactDetails.zip.$error">
            <div class="custom-error-class" v-if="!$v.editContactDetails.zip.minLength">
              Minimum 2 characters required.
            </div>
            <div
              class="custom-error-class"
              v-else-if="!$v.editContactDetails.zip.isPostalCode && editContactDetails.zip"
            >
              Valid Zip/Postal Code Required
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">Country:</div>
        <div class="ft-normal" v-if="!updateContact">
          {{ account.country }}
        </div>
        <div class="row col-xs-12 col-sm-6 col-md-5" v-else-if="countriesList">
          <multiselect
            class="multiselect-single-dropdown mr-bt--6 required"
            :class="$v.editContactDetails.country_id.$error ? 'invalid-border' : ''"
            :allow-empty="false"
            placeholder="Select a country"
            label="country_name"
            v-model="editContactDetails.country_id"
            :show-labels="false"
            :options="countriesList.map((type) => type.id)"
            :custom-label="(opt) => countriesList.find((x) => x.id === opt).country_name || ''"
          ></multiselect>
          <span class="required_astric left-130" v-if="!editContactDetails.country_id">*</span>
          <div
            class="custom-error-class"
            v-if="
              !$v.editContactDetails.country_id.required && $v.editContactDetails.country_id.$error
            "
          >
            Complete required field
          </div>
        </div>
      </div>
      <div class="d-flex row m-0 plr-20">
        <div class="w-175">Phone Number :</div>
        <div class="ft-normal" v-if="!updateContact">
          {{ account.phone_number }}
        </div>
        <div class="row col-xs-12 col-sm-6 col-md-5" v-else>
          <input
            type="text"
            class="form-control"
            placeholder="Phone number"
            maxlength="20"
            v-model="editContactDetails.phone_number"
            @blur="$v.editContactDetails.phone_number.$touch()"
            :class="$v.editContactDetails.phone_number.$error ? 'invalid-border' : ''"
          />
          <div
            class="custom-error-class"
            v-if="
              !$v.editContactDetails.phone_number.isNumber &&
              $v.editContactDetails.phone_number.$error
            "
          >
            Please enter only numbers
          </div>
        </div>
      </div>
      <div class="row m-0 plr-20 align-right">
        <template v-if="!updateContact">
          <button type="button" class="btn emergo-green-button" @click="contactUpdate">
            Update
          </button>
        </template>
        <template v-else>
          <button type="button" class="btn emergo-white-button" @click="updateContact = false">
            Cancel
          </button>
          <button
            type="button"
            class="btn emergo-green-button ml-15 xs-mrt-10"
            :disabled="disableContactSave"
            @click="updateContactDetails"
          >
            Save
          </button>
          <!-- :disabled="disableButtonForProfile || loaderStatus" -->
        </template>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <account-history-popup :accountId="accountId"></account-history-popup>
  </div>
</template>
<script>
import _ from 'lodash';
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import Multiselect from 'vue-multiselect';
import { required, minLength } from 'vuelidate/lib/validators';
import {
  isAllowedCharacters,
  isAlphaNum, // eslint-disable-line no-unused-vars
  isNumber,
  isPostalCode
} from '../Register/validator';
import { getCountries, checkCompanyName } from '../../apis/register';
import {
  getAccountDetails,
  getUserById,
  updateAccountName,
  updateContactDetails
} from '../../apis/accountDetails';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import AccountHistoryPopup from './AccountHistoryPopup.vue';

export default {
  data() {
    return {
      account: {},
      loaderStatus: false,
      account_owner: null,
      updateAccount: false,
      updateContact: false,
      editAccount: {},
      editContactDetails: {},
      countriesList: [],
      companyExists: false,
      specialCharacterErrMsg: 'The following characters are not allowed: * ? < > ! @ # $ “ % ^'
    };
  },
  validations: {
    editContactDetails: {
      city: {
        minLength: minLength(3),
        isAllowedCharacters
      },
      state: {
        isAllowedCharacters
      },
      country_id: {
        required
      },
      phone_number: {
        isNumber
      },
      street_address: {
        isAllowedCharacters
      },
      zip: {
        minLength: minLength(2),
        isPostalCode
      }
    },
    editAccount: {
      account_name: {
        required,
        minLength: minLength(2),
        isAlphaNum
      }
    }
  },
  components: { Loader, Multiselect, AccountHistoryPopup },
  watch: {
    account() {
      this.$emit('input', this.account);
    }
  },
  computed: {
    disableAccountSave() {
      if (this.$v.editAccount.$invalid) return true;
      if (!this.editAccount.account_name) return true;
      if (this.editAccount.account_name === this.account.account_name) return true;
      return false;
    },
    disableContactSave() {
      if (this.$v.editContactDetails.$invalid) return true;
      if (_.isEqual(this.editContactDetails, this.account)) return true;
      return false;
    }
  },
  props: ['accountId'],
  methods: {
    debounceInput: _.debounce(function () {
      //eslint-disable-line
      this.$v.editAccount.account_name.$touch();
      this.checkCompanyName();
    }, 1000),
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    async getAccountDetails() {
      this.loaderStatus = true;
      const data = await getAccountDetails(this.accountId);
      this.loaderStatus = false;
      if (!data) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch Account details',
          group: 'custom-notification'
        });
      } else {
        this.account = data;
        EventBus.$emit('usersCount', this.account.number_of_users);
        if (this.account.account_owner_id) {
          this.account_owner = await getUserById(this.account.account_owner_id);
        } else {
          this.account_owner = null;
        }
      }
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${
        lastname ? lastname.charAt(0).toUpperCase() : ''
      }`;
    },
    accountUpdate() {
      // eslint-disable-next-line no-multi-assign
      this.$set(this.editAccount, 'account_name', this.account.account_name);
      this.updateAccount = true;
    },
    contactUpdate() {
      // eslint-disable-next-line no-multi-assign
      this.editContactDetails = cloneDeep(this.account);
      this.updateContact = true;
    },
    async updateAccountName() {
      const data = {
        account_name: this.editAccount.account_name,
        account_id: this.accountId
      };
      this.loaderStatus = true;
      const response = await updateAccountName(data);
      this.loaderStatus = false;
      if (response.status_code === 200) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: response.data,
          group: 'custom-notification'
        });
        this.updateAccount = false;
        await this.getAccountDetails();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update Account name.',
          group: 'custom-notification'
        });
      }
    },
    async updateContactDetails() {
      const data = {
        account_id: this.accountId,
        city: this.editContactDetails.city,
        country_id: this.editContactDetails.country_id,
        phone_number: this.editContactDetails.phone_number,
        state: this.editContactDetails.state,
        street_address: this.editContactDetails.street_address,
        zip: this.editContactDetails.zip
      };
      this.loaderStatus = true;
      const response = await updateContactDetails(data);
      this.loaderStatus = false;
      if (response.status_code === 200) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: response.data,
          group: 'custom-notification'
        });
        this.updateContact = false;
        await this.getAccountDetails();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update Contact details.',
          group: 'custom-notification'
        });
      }
    },
    async loadCountries() {
      this.countriesList = await getCountries();
    },
    async checkCompanyName() {
      if (this.editAccount.account_name === this.account.account_name) {
        this.companyExists = false;
      } else if (
        !this.$v.editAccount.account_name.$error &&
        this.editAccount.account_name !== this.account.account_name
      ) {
        this.loaderStatus = true;
        this.companyExists = await checkCompanyName({
          company_name: this.editAccount.account_name
        });
        this.loaderStatus = false;
      }
    },
    openAccountHistory() {
      $('#accountHistory').modal({
        backdrop: 'static',
        keyboard: false
      });
    }
  },
  async created() {
    await this.getAccountDetails();
    await this.loadCountries();
  }
};
</script>
<style scoped>
.d-flex {
  display: flex;
  min-height: 60px;
}
.flex-end {
  justify-content: flex-end;
}
.link-history {
  color: #2f80ed;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  cursor: pointer;
  text-decoration: underline;
}
.w-175 {
  width: 175px;
  padding-top: 6px;
}
.m-15 {
  margin: 15px;
}
.plr-20 {
  padding: 0 20px;
}
.ml-15 {
  margin-left: 15px;
}
.ft-20 {
  font-size: 20px;
  font-weight: normal;
}
.border-box {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin: 15px;
  padding: 15px 0px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
}
.btn {
  width: 120px;
}
hr {
  border-top: 1px solid #acacac;
}
.ft-normal {
  font-weight: normal;
  padding-left: 13px;
  padding-top: 6px;
}
.relative-pos {
  position: relative;
}
.custom-profile-pic-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  background: #f2f2f2;
  color: #00518a;
}
.member-name {
  font-size: 14px;
  line-height: 16px;
  font-weight: normal;
}
.member-email {
  font-size: 14px;
  line-height: 16px;
  font-weight: 300;
}
.member_img {
  display: table-cell;
  vertical-align: middle;
  padding-right: 15px;
}
.member-text {
  display: table-cell;
  word-break: break-all;
}
.mr-bt--6 {
  margin-bottom: -6px;
}

input::placeholder {
  font-size: 16px;
}
input:-ms-input-placeholder {
  font-size: 16px;
}

.required_astric {
  color: red;
  display: block;
  position: absolute;
  top: 0.4em;
}
input::placeholder:after {
  content: ' *';
}
.left-130 {
  left: 130px;
}
.left-190 {
  left: 190px;
}
.custom-error-class {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #b00505;
  padding: 5px 0 0 13px;
}
.custom-warning-class {
  color: #f18a21;
  padding: 5px 0 0 13px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.invalid-border {
  border-color: #a20000;
}
.warning-border {
  border-color: #f18a21;
}
::v-deep .multiselect-single-dropdown .multiselect__option--selected:before {
  right: 10px;
}
@media only screen and (max-width: 767px) {
  .d-flex {
    display: block;
    height: auto;
    margin-bottom: 20px;
  }
  .ft-normal {
    padding: 0;
  }
  .flex-end {
    text-align: right;
  }
}
@media only screen and (max-width: 374px) {
  .flex-end {
    text-align: left;
  }
  .btn {
    width: 100%;
  }
  .xs-mrt-10 {
    margin-top: 10px;
    margin-left: 0;
  }
}
</style>
